import { jsx } from "react/jsx-runtime";
import { Button as Button$1 } from "@mui/material";
import { forwardRef } from "react";
import { ICON_COLOR_VAR_NAME } from "../common/Common.js";
import { spreadSx } from "../../utils/spreadSx.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
const Button = forwardRef(
  ({ children, strokeIcon, cancelIconFilling, variant = "contained", ...rest }, ref) => /* @__PURE__ */ jsx(
    Button$1,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      ref,
      variant,
      ...rest,
      sx: [
        ...spreadSx(rest.sx),
        cancelIconFilling ? {} : strokeIcon ? {
          "svg path": {
            stroke: `var(${ICON_COLOR_VAR_NAME})!important`
          }
        } : {
          "svg path": { fill: `var(${ICON_COLOR_VAR_NAME})!important` }
        }
      ],
      children
    }
  )
);
Button.displayName = "Button";
export {
  Button
};
//# sourceMappingURL=Button.js.map
